/** §5.2 — the citation contract. SRE-FR-003/005/010/015, RG-FR-002, RC-FR-005. */

export interface Citation {
  id: string
  /** Marker rendered in text, e.g. 2 for `[2]`. */
  index: number
  title: string
  url?: string
  publisher?: string
  /** ISO date the source was published. */
  publishedAt?: string
  /** ISO date the crawler retrieved it — distinct from publication (SRE-FR-005). */
  retrievedAt?: string
  /**
   * The passage the claim was derived from, capped at 200 chars by SRE-FR-005.
   * Truncation happens server-side; the client renders what it is given.
   */
  passage?: string
  /** 0–1 domain/recency credibility score (SRE-FR-003). */
  credibility?: number
  /** SRE-FR-010 — uploaded by the client rather than discovered. */
  clientProvided?: boolean
  /** SRE-FR-015 — from a paid database, which constrains redistribution. */
  licensed?: boolean
  licenseNote?: string
}

/** SRE-FR-003 credibility bands. */
export const CREDIBILITY_BANDS = [
  { min: 0.8, label: 'Authoritative', tone: 'verified' as const },
  { min: 0.6, label: 'Credible', tone: 'info' as const },
  { min: 0.4, label: 'Use with caution', tone: 'warning' as const },
  { min: 0, label: 'Low credibility', tone: 'critical' as const },
]

export function credibilityBand(score: number) {
  return CREDIBILITY_BANDS.find((b) => score >= b.min) ?? CREDIBILITY_BANDS[CREDIBILITY_BANDS.length - 1]!
}

/** SRE-FR-006 — a contradiction between two claims, presented without resolution. */
export interface EvidenceConflict {
  id: string
  claimA: { text: string; citationIds: string[] }
  claimB: { text: string; citationIds: string[] }
  /** Optional note on *why* they conflict. Must not adjudicate. */
  note?: string
}
